module.exports = __webpack_public_path__ + "img/portugal-other-heart-diseases-female.b874cb96.png";